<template>
  <div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
    <div>
      <NavBarOnly></NavBarOnly>
      <div class="conteudo cor-secundaria-bg" style="position: unset;">
        
        <logo-empresa></logo-empresa>
        <h1 class="splash-texto-2 splash-cor-2" >{{ $t('faca_seu_login') }}</h1>
        <div class="row" style="width: 100% !important; margin-bottom: 0px;">
          <div class="input-field col s12" @input="FazerLogin(false)">
            <the-mask 
              id="telefone" 
              v-model="telefone" 
              type="tel" required :masked="true"
              :mask="['(##) ####-####','(##) #####-####']" 
              
             
              />
              <label for="telefone" class="label splash-cor-1">{{ $t('informe_seu_whatsapp') }}</label>
          </div>
          <div class="input-field col s12 splash-cor-1" >
            <input id="nome" type="text" class="validate" v-model="nome" >
            <label for="nome" class="label splash-cor-1">{{ $t('informe_seu_nome_e_sobrenome') }}</label>
          </div>          
        </div>        
        <br>
        <div v-if="telefone.length === 15" class="btn waves-effect waves-light cor-primaria-bg" @click="ValidarLogin()" style="padding: 0; width: 100%">
          <div class="">
            <div class="col s12" style="margin-left: auto; margin-right: auto; font-weight: bold">
              {{ $t('continuar') }}
            </div>
          </div>
       </div>
       <br>
       <div v-if="clienteLogado && podeAcompanharPedidos" class="btn waves-effect waves-light cor-meus-pedidos" @click="UltimosPedidos()" style="padding: 0; width: 100%">
          <div class="">
            <div class="col s12" style="margin-left: auto; margin-right: auto; font-weight: bold">
              {{ $t('meus_pedidos') }}
            </div>
          </div>
       </div>       
       <br>
       <div class="btn waves-effect waves-light red" @click="Sair()" style="padding: 0; width: 100%">
          <div class="">
            <div class="col s12" style="margin-left: auto; margin-right: auto; font-weight: bold">
              {{ $t('cancelar') }}
            </div>
          </div>
        </div>
       <div style="height: 400px;"></div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBarOnly from "../../Widgets/NavBarOnly";
import LogoEmpresa from "../../Widgets/LogoEmpresa";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";
import {SalvarLoginDoClienteNoNavegador, ChecarLogin} from "../../../services/auth"; 
import Swal from 'sweetalert2';
import _ from 'lodash';
export default {
  name: "Login",
  components: {
    LogoEmpresa,
    NavBarOnly,
    Loading
  },
  computed: {
    podeAcompanharPedidos() {
      const empresa = this.$store && this.$store.state ? this.$store.state.empresa : null;
      const flag = empresa ? empresa.desativar_acompanhar_ultimo_pedido : null;
      return String(flag || "N").trim().toUpperCase() !== "S";
    }
  },
  async mounted() {
    window.scrollTo(0, 0);
    this.VerificarEmpresa();
    let clienteLogado = await ChecarLogin(this.$store.state.apiUrl);
    this.$store.commit("isClienteLogado", clienteLogado);
    this.clienteLogado = clienteLogado;    

    if (this.clienteLogado && this.podeAcompanharPedidos) {
       this.UltimosPedidos();
    }    
  },
  data() {
    return {
      email:"",
      telefone: "",
      nome: "",
      isLoading: false,
      clienteLogado: false,
      //clienteLogado: this.$store.state.is_cliente_logado,
      fullPage: true
    };
  },
  methods: {
    async Sair() {
      this.$router.push("/" + this.$store.state.empresa_url);
    },
    async VerificarEmpresa()
    {
        this.isLoading = true;
        this.$store.commit('empresaUrl', this.$router.currentRoute.params.empresa);
        await axios.get(this.$store.state.apiUrl + 'empresa/' + this.$store.state.empresa_url)
        .then(res => {
          if(res.data) {
            this.isLoading = false;
            this.$store.commit('empresa', res.data);
            this.empresaExiste = true;
          }
        })
        .catch(error => this.isLoading = false);

        if(!this.empresaExiste){
          window.open(this.retorno.empresa.empresa_url, '_blank');
        }
          
    },
    OnlyNumbers(string){
      return string.replace(/\D/g, ''); 
    },
    FazerLogin(validacoes) {
      let telefone = this.OnlyNumbers(this.telefone);

      // Verifica se o telefone tem exatamente 11 dígitos
      if (telefone.length !== 11) {
        if (validacoes) alert("O telefone deve ter 11 dígitos.");
        return; // Interrompe a execução do método
      }

      // Se chegou aqui, o telefone tem 11 dígitos
      this.isLoading = true; // Ativa o indicador de carregamento

      axios.post(this.$store.state.apiUrl + "cliente/login", { telefone })
        .then(response => {
          this.nome = response.data.cliente.nome;
          this.clienteLogado = true;
          this.$nextTick(() => {
            M.updateTextFields();
          });
          SalvarLoginDoClienteNoNavegador(response.data.cliente);
        })
        .catch(error => {
          console.error("Erro na requisição:", error);
          if (validacoes) {
            const errorMessage = (error.response && error.response.data && error.response.data.message) || "Erro ao realizar login";
            alert(errorMessage);
          }
        })
        .finally(() => {
          this.isLoading = false; // Desativa o indicador de carregamento
        });
    },    
    async ValidarLogin (){
      if(this.clienteLogado){
        this.$router.push("/" + this.$store.state.empresa_url + "/menu");
      } else {
        Swal.fire({
          title: "Realizar o Cadastro",
          text: "O número informado não possuí cadastro, deseja se cadastrar?",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Sim, realizar cadastro!",
          cancelButtonText: "Cancelar",
        }).then((result) => {
          if (result.value) {
            this.CadastrarCliente();
          }
        });        
        
      }
    },
    UltimosPedidos() {
      if (!this.podeAcompanharPedidos) return;
      this.$router.push("/" + this.$store.state.empresa_url + "/cliente-pedidos");
    },    
    async CadastrarCliente() {

      let telefone = this.OnlyNumbers(this.telefone);
      if(telefone.length !== 11){
        return alert("Preencha corretamente o telefone");
      }
      if(!this.nome){
        return alert("Preencha o nome");
      }

      this.isLoading = true;
      await axios.post(this.$store.state.apiUrl + "cliente/cadastrar", {telefone, nome: this.nome})
      .then(response => {
        this.isLoading = false;
        this.clienteLogado = true;
        SalvarLoginDoClienteNoNavegador(response.data.cliente);
        this.ValidarLogin();
        return response.data.cliente;
      }).catch(error => {
        alert('Ocorreu um erro durante o cadastro, verifique seus dados');
        this.isLoading = false;
        return null;
      });
    },    
  }
};
</script>

<style scoped>
  @import '../../../assets/css/conteudo-splash.css';
  @import '../../../assets/css/paginas-inicio.css';

  .label-fields {
    text-align: left;
    padding-bottom: -10px;
  }
  .cor-meus-pedidos {
    background-color: #2196F3; /* Azul */
  }
</style>



// WEBPACK FOOTER //
// src/components/Paginas/AreaCliente/Login.vue